import React, { memo } from 'react'
import RefreshIcon from 'transfix-icons/build/RefreshIcon'
import TrophyIcon from 'transfix-icons/build/TrophyIcon'
import { formatRelativeTime } from 'transfix-ui/components/RelativeDateTime/utils'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export interface ICarrierOptionAcceptedCardProps {
  acceptedAt: string
  isCounterBidAccepted: boolean
}
const useCarrierOptionAcceptedCardStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: brandColors.gold0,
    padding: theme.spacing(1.5),
    gap: theme.spacing(1),
  },
  icons: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
}))

const CarrierOptionAcceptedCard = memo<ICarrierOptionAcceptedCardProps>(
  ({ acceptedAt, isCounterBidAccepted }) => {
    const classes = useCarrierOptionAcceptedCardStyles()

    return (
      <div className={classes.root}>
        <div className={classes.icons}>
          <TrophyIcon size='xlarge' color='gold2' />
          {isCounterBidAccepted && <RefreshIcon size='large' color='gold2' />}
        </div>
        <Typography variant='subtitle1' component='div'>
          {`This option${
            isCounterBidAccepted ? "'s counter offer" : ''
          } was accepted ${formatRelativeTime({ datetime: acceptedAt })} ago`}
        </Typography>
      </div>
    )
  }
)

export default CarrierOptionAcceptedCard
